"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Coachmark = void 0;
var Utilities_1 = require("../../Utilities");
var Coachmark_styles_1 = require("./Coachmark.styles");
var Coachmark_base_1 = require("./Coachmark.base");
exports.Coachmark = (0, Utilities_1.styled)(Coachmark_base_1.CoachmarkBase, Coachmark_styles_1.getStyles, undefined, {
    scope: 'Coachmark',
});
//# sourceMappingURL=Coachmark.js.map